module.exports = __webpack_public_path__ + "img/congratulation.6efb7d54.png";